export default __webpack_public_path__ + "static/media/logo-mui.193afe7a.png";